<template>
    <div class="benefit-container">
        <button class="benefit-card" @click="toggleModal">
            <div class="image-container">
              <img :src="benefitImageUrlFromTheme" class="background-image" />
            </div>
            <div class="content-box">
                <div class="text-content">
                    <div class="title-points">
                        <div>
                            <h3 class="benefit-title">{{ benefit.name }}</h3>
                            <p class="benefit-subtitle">{{ benefit.merchant.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </button>

        <div v-if="isActive" class="modal-overlay" @click.self="toggleModal">
            <div class="modal-content">
                <div class="modal-card">
                    <img :src="benefitImageUrlFromTheme" alt="Benefit Image" class="modal-image" />

                    <div class="modal-info-overlay">
                        <div class="modal-info">
                            <h3 class="modal-title">{{ benefit.name }}</h3>
                            <p class="modal-subtitle">{{ benefit.merchant.name }}</p>
                            <p class="modal-description">{{ benefit.desc }}</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="isLast && !isActive" class="show-all-overlay" @click="redirectToBenefits">
            <span>Show All Benefits</span>
        </div>
    </div>
</template> 

<script>
import { benefitImageMixin } from '@/composables/useBenefitImage';

export default {
  mixins: [benefitImageMixin],
  props: {
    benefit: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isLast: { // Check if it's the last benefit
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localIsActive: this.isActive,
    };
  },
  watch: {
    isActive(newValue) {
      this.localIsActive = newValue;
    },
  },
  methods: {
    toggleModal() {
      this.localIsActive = !this.localIsActive;
      this.$emit('update:isActive', this.localIsActive); 
      this.$emit('toggleModal');
    },
    redirectToBenefits() {
      this.$router.push('/client/benefit'); // Redirect to 'Show All Benefits' page
    }
  },
};
</script>

<style scoped>
.benefit-container {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.benefit-card {
  position: relative;
  width: 100%;
  max-width: 800px;
  height: 150px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  border: none;
  padding: 0;
  background: none;
  text-align: left;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row; 
  transition: all 0.3s ease-in-out;
}

.benefit-card.expanded {
  height: 350px; 
}

.image-container {
  width: 200px;
  height: 100%;
  flex-shrink: 0; 
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-box {
  flex-grow: 1; 
  background: #fff;
  border-radius: 0 8px 8px 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
}

.benefit-title {
  font-size: 18px; 
  font-weight: bold;
  color: #333;
  margin: 0;
}

.benefit-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  margin-top: 8px;
}

.show-all-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Transparent white */
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  border-radius: 15px;
}

.show-all-overlay:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

.show-all-overlay span {
  font-size: 18px;
  color: #ff4b4b;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-info-overlay {
  position: absolute; /* Ubah untuk posisi absolut agar overlay dapat melayang di atas gambar */
  bottom: 10%; /* Atur jarak dari bagian bawah agar ada ruang untuk gambar */
  left: 5%; /* Menyisakan ruang di sisi kiri */
  right: 5%; /* Menyisakan ruang di sisi kanan */
  width: auto; /* Biarkan lebarnya otomatis menyesuaikan */
  background-color: rgba(255, 255, 255, 0.9); /* Ganti latar belakang menjadi putih transparan */
  border-radius: 12px; /* Sudut membulat untuk overlay */
  padding: 20px; /* Padding untuk ruang di dalam */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); /* Tambahkan bayangan untuk efek elevasi */
  z-index: 2; /* Pastikan overlay di atas gambar */
  text-align: left; /* Rata kiri untuk teks modal */
}

.modal-content {
  position: relative; /* Custom positioning */
  width: 90%; /* Lebar responsif */
  max-width: 600px; /* Maksimum untuk desktop */
  max-height: 90vh; /* Maximum height */
  border-radius: 25px; /* Edge rounding */
  overflow-y: auto; /* For scrolling long content */
}

.modal-image {
  width: 100%;
  height: auto; /* Menjaga proporsi */
  aspect-ratio: 1; /* Membuat gambar menjadi persegi */
  object-fit: cover; /* Menjaga gambar penuh ke dalam kontainer */
  display: block;
  border-radius: 12px; /* Menghilangkan margin bawah, karena overlay akan melindungi bagian bawah */
}

.modal-info {
  text-align: left; /* Rata kiri untuk teks modal */
}

.modal-title {
  font-size: 20px; /* Ukuran font untuk judul */
  font-weight: bold; /* Tebal untuk judul */
  margin: 0 0 8px 0; /* Margin bawah untuk pemisahan */
  color: #333; /* Warna untuk judul */
}

.modal-subtitle {
  font-size: 16px; /* Ukuran font untuk subtitle */
  color: #666; /* Warna abu-abu untuk subtitle */
  margin: 0 0 12px 0; /* Margin untuk pemisahan */
}

.modal-description {
  font-size: 14px; /* Ukuran font untuk deskripsi */
  color: #444; /* Warna untuk deskripsi */
  line-height: 1.4; /* Jarak antar baris untuk keterbacaan */
}
.benefit-title, .benefit-subtitle {
  word-wrap: break-word; /* Ensure long words break and wrap properly */
  overflow-wrap: break-word; /* Additional property for text wrapping */
  margin: 0;
  padding: 0;
}
@media (max-width: 768px) {
  .modal-content {
    width: 95%; /* Lebar responsif untuk modal pada mobile */
  }

  .modal-title {
    font-size: 20px; /* Ukuran font untuk judul pada layar mobile */
  }

  .modal-subtitle {
    font-size: 16px; /* Ukuran font untuk subtitle pada layar mobile */
  }

  .modal-description {
    font-size: 14px; /* Ukuran font untuk deskripsi pada layar mobile */
  }

  .modal-image {
    width: 100%;
    height: auto; /* untuk menjaga proporsi gambar */
    aspect-ratio: 1 / 1; 
    object-fit: cover; 
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    font-size: 12px; /* Ukuran font responsif untuk layar kecil */
  }

  .modal-title {
    font-size: 18px; /* Lebih kecil untuk layar kecil */
  }

  .modal-subtitle {
    font-size: 14px; /* Lebih kecil untuk subtitle */
  }

  .modal-description {
    font-size: 12px; /* Lebih kecil untuk deskripsi */
  }
}
</style>